let customqty = false;

document.getElementById('onetimeswitch').addEventListener('click', () => {
  document.querySelector('.qtycontainer').style.display = 'block';
  document.querySelectorAll('.qtycontainer .tab__input').forEach(el => el.checked = false);
  document.querySelector('.subscribesavings').style.display = 'none';
  document.querySelector(".onetimebtns .defaultoption").checked = true;
  document.querySelector(".daysbetween").innerHTML = "30";
  customqty = false;
});

document.getElementById('subscribeswitch').addEventListener('click', () => {
  document.querySelector('.qtycontainer').style.display = 'none';
  document.querySelectorAll('.qtycontainer .tab__input').forEach(el => el.checked = false);
  document.querySelector('.subscribesavings').style.display = 'block';
  document.querySelector(".subscribebtns .defaultoption").checked = true;
  document.querySelector(".daysbetween").innerHTML = "30";
  customqty = false;
});

document.querySelectorAll(".subscribebtns input").forEach(input => {
  input.addEventListener('change', function () {
    const freq = this.dataset.freq;
    document.querySelector(".daysbetween").innerHTML = freq;
  });
});

document.querySelectorAll('.addmultipacktocart').forEach(button => {
  button.addEventListener('click', () => {
    const elem = document.querySelector('.multipackcontain input[name="multipackform"]:checked');
    const subscribeid = elem?.dataset.subscribe;
    const frequency = elem?.dataset.freq;
    const sellingplan = elem?.dataset.sellingplan;
    let qty = customqty ? document.querySelector('.numberbtn').value : 1;

    addItemToCart(subscribeid, qty, frequency, "Days", sellingplan);
  });
});

document.querySelector('.onetimebtns')?.addEventListener('click', () => {
  document.querySelectorAll('.qtycontainer .tab__input').forEach(el => el.checked = false);
  customqty = false;
});

document.querySelectorAll(".qtycontainer .tab__input").forEach(input => {
  input.addEventListener('change', function () {
    if (this.checked) {
      document.querySelector(".onetimebtns .customoption").checked = true;
      customqty = true;
    } else {
      document.querySelector(".onetimebtns .defaultoption").checked = true;
      customqty = false;
    }
  });
});

document.querySelectorAll('.addmultipackdesk').forEach(button => {
  button.addEventListener('click', function () {
    const elem = this.parentElement;
    const subscribeid = elem?.dataset.subscribe;
    const frequency = elem?.dataset.freq;
    const sellingplan = elem?.dataset.sellingplan;
    let qty = customqty ? document.querySelector('.numberbtn').value : 1;

    addItemToCart(subscribeid, qty, frequency, "Days", sellingplan);
  });
});

function addItemToCart(variant_id, qty, frequency, unit_type, sellingplan) {
  let data = sellingplan == null
    ? { id: variant_id, quantity: qty }
    : { id: variant_id, quantity: 1, selling_plan: sellingplan };

  console.log(data);

  const xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        fetchCartDrawer();
    }
  };

  xhr.open("POST", "/cart/add.js", true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.send(new URLSearchParams(data).toString());
}

function rudrSwitchTab(rudr_tab_id, rudr_tab_content) {
  document.querySelectorAll(".tabcontent").forEach(tab => tab.style.display = 'none');
  document.getElementById(rudr_tab_content).style.display = 'block';

  document.querySelectorAll(".multipackbtn").forEach(btn => btn.className = 'multipackbtn');
  document.getElementById(rudr_tab_id).className = 'multipackbtn tabmenu active';
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".plusbtn")?.addEventListener("click", () => {
    let val = parseInt(document.querySelector(".numberbtn").value || 0, 10);
    if (++val >= 0) document.querySelector(".numberbtn").value = val;
  });

  document.querySelector(".minusbtn")?.addEventListener("click", () => {
    let val = parseInt(document.querySelector(".numberbtn").value || 0, 10);
    if (--val >= 0) document.querySelector(".numberbtn").value = val;
  });
});